// src/lib/sgds-dom.ts
//
// SGDS's `onSgdsChange`/`onSgdsInput` handlers type as a generic
// `(event: CustomEvent) => void` for most controls — the current value lives on
// `event.target` (the underlying custom element instance), typed here as
// `HTMLElement` in the library's own JSX typings. This one small cast point
// stands in for the native `HTMLInputElement`/`HTMLSelectElement` the DOM would
// otherwise give us.
export interface SgdsValueElement extends HTMLElement {
  value: string
}

export function targetValue(event: Event): string {
  return (event.target as SgdsValueElement).value
}
